module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Cutting board-f18ad03ac3addb9d248106394042e50a.svg";